import React, {createContext, useState, useEffect} from 'react'
// import ProductsAPI from './api/ProductsAPI'
// import UserAPI from './api/UserAPI'
//import CategoriesAPI from './api/CategoriesAPI'


import axios from 'axios'

export const GlobalState = createContext()


export const DataProvider = ({children}) =>{
    const [token, setToken] = useState(false)


    useEffect(() =>{
        const firstLogin = localStorage.getItem('firstLogin')
        if(firstLogin){
            const refreshtoken = async () =>{
                const res = await axios.get('/user/refresh_token')
                
                setToken(res.data.accesstoken)
    
                setTimeout(() => {
                    refreshtoken()
                }, 10 * 60 * 1000)
            }
            refreshtoken()
        }
    },[])


    
    const state = {
        token: [token, setToken],
        // ProductsAPI: ProductsAPI(),
        // userAPI: UserAPI(token),
        //categoriesAPI: CategoriesAPI()

        
    }

    return (
        <GlobalState.Provider value={state}>
            {children}
        </GlobalState.Provider>
    )
}